import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import UserNavigationMenu from 'components/manager/shared/userNavigationMenu/component';
import { userAuthLogoutRequestAction } from '../../../../redux/actions/userAuthorization.actions';
HeaderDropdown.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func.isRequired,
    profileRef: PropTypes.object
};
export default function HeaderDropdown(_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, setOpen = _a.setOpen, profileRef = _a.profileRef;
    var userSession = useSelector(function (state) { return state.userAuthorization.userSession; });
    var dispatch = useDispatch();
    var logoutRequest = function () { return dispatch(userAuthLogoutRequestAction()); };
    var nodeRef = useRef(null);
    useEffect(function () {
        document.addEventListener('mousedown', outsideClickHandler);
        return function () {
            document.removeEventListener('mousedown', outsideClickHandler);
        };
    }, []);
    function outsideClickHandler(_a) {
        var target = _a.target;
        if (profileRef.current && !profileRef.current.contains(target)) {
            setOpen(false);
        }
    }
    return (React.createElement(CSSTransition, { in: open, timeout: 500, classNames: "anim-fade", unmountOnExit: true, nodeRef: nodeRef },
        React.createElement("div", { className: "admin-actions-menu", ref: nodeRef },
            React.createElement(UserNavigationMenu, { userRank: userSession.rank, logoutRequest: logoutRequest }))));
}
